/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskReportsCustomCreateRoute } from '@jira/router-routes__servicedesk-reports-routes/src/servicedeskReportsCustomCreateRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import CustomCreate, {
	LazyServicedeskReportsCustomCreate,
} from './ui/custom-create-view/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskReportsCustomCreateRouteEntry: Route = createEntry(
	servicedeskReportsCustomCreateRoute,
	() => ({
		group: 'servicedesk',
		perfMetricKey: 'service-management.reports.custom-create',
		// eslint-disable-next-line no-restricted-syntax
		component: CustomCreate,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskReportsCustomCreate],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
